var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 13.6663C3.31802 13.6663 0.333252 10.6815 0.333252 6.99967C0.333252 3.31777 3.31802 0.333008 6.99992 0.333008C10.6818 0.333008 13.6666 3.31777 13.6666 6.99967C13.6666 10.6815 10.6818 13.6663 6.99992 13.6663ZM6.99992 12.333C9.94545 12.333 12.3333 9.94521 12.3333 6.99967C12.3333 4.05415 9.94545 1.66634 6.99992 1.66634C4.0544 1.66634 1.66659 4.05415 1.66659 6.99967C1.66659 9.94521 4.0544 12.333 6.99992 12.333ZM7.66658 6.99967H10.3333V8.33301H6.33325V3.66634H7.66658V6.99967Z",
    fill: "#5A6872"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.f76ade839245aa53908386285f37bde4.svg";
export { ForwardRef as ReactComponent };